<p>edit-data-dialog works!</p>
